/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit BlueBarRange/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaSelectOne from 'DesignSystem/TysiaSelectOne/index'
import TysiaSelectOneArrow from 'DesignSystem/TysiaSelectOne/TysiaSelectOneArrow/index'
import TysiaSelectOneContent from 'DesignSystem/TysiaSelectOne/TysiaSelectOneContent/index'
import TysiaSelectOneInput from 'DesignSystem/TysiaSelectOne/TysiaSelectOneInput/index'
import TysiaSelectOneOptions from 'DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/index'
import TysiaSelectOnePopover from 'DesignSystem/TysiaSelectOne/TysiaSelectOnePopover/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function BlueBarRange({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/Calendar/Content/Content/Topbar/LowerSection/SettingsAction/Settings/BlueBarRange"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let settingsValueData = fromData.useDataFormat({ viewPath,
context: 'settings',
format: fromHelpers.getDays,
})
let settingsBlueBarRangeBeforeValueData = fromData.useDataValue({ viewPath,
context: 'settings',
path: 'blue_bar_range.before',
})
let onChange = fromHelpers.useOnChangeBefore({
  children,
  viewPath
  
})
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let settingsValueData1 = fromData.useDataFormat({ viewPath,
context: 'settings',
format: fromHelpers.getDays,
})
let settingsBlueBarRangeAfterValueData = fromData.useDataValue({ viewPath,
context: 'settings',
path: 'blue_bar_range.after',
})
let onChange1 = fromHelpers.useOnChangeAfter({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<div
  data-testid="BlueBarRange.Vertical"
  data-view-path={viewPath}
 style={{'--g-1-Z2jklRt': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bc-2-Z2jklRt': dtColorsWhite}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="BlueBarRange.Vertical:1"
  data-view-path={viewPath}
 style={{'--pt-3-Z2jklRt': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pr-4-Z2jklRt': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-5-Z2jklRt': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pl-6-Z2jklRt': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Show recommended next visit date"
/>
</div>
<div
  data-testid="BlueBarRange.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-Z2jklRt': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-3-Z2jklRt': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pr-4-Z2jklRt': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-5-Z2jklRt': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pl-6-Z2jklRt': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Highlight"
/>
<TysiaSelectOne
  viewPath={`${viewPath}/TysiaSelectOne`}
 marginTop={0}
 maxWidth={45}
 data="settings"
 format="helpers.js getDays"
 from={settingsValueData}
 data="settings.blue_bar_range.before"
 value={settingsBlueBarRangeBeforeValueData}
 onChange={onChange}
>
{childProps => (
<TysiaSelectOneContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneContent`}
 paddingTop={dtSpaceXxxs}
 paddingRight={dtSpaceXxxs}
 paddingBottom={dtSpaceXxxs}
 paddingLeft={dtSpaceXxxs}
 optionsWidth={56}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneInput
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneInput`}
/>
<TysiaSelectOneArrow
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneArrow`}
 size="small"
 paddingLeft={0}
 paddingRight={0}
/>
<TysiaSelectOnePopover
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOnePopover`}
>
{childProps => (
<TysiaSelectOneOptions
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneOptions`}
/>
)}
</TysiaSelectOnePopover>
</React.Fragment>
)}
</TysiaSelectOneContent>
)}
</TysiaSelectOne>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="before &"
/>
<TysiaSelectOne
  viewPath={`${viewPath}/TysiaSelectOne`}
 marginTop={0}
 maxWidth={45}
 data="settings"
 format="helpers.js getDays"
 from={settingsValueData1}
 data="settings.blue_bar_range.after"
 value={settingsBlueBarRangeAfterValueData}
 onChange={onChange1}
>
{childProps => (
<TysiaSelectOneContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneContent`}
 paddingTop={dtSpaceXxxs}
 paddingRight={dtSpaceXxxs}
 paddingBottom={dtSpaceXxxs}
 paddingLeft={dtSpaceXxxs}
 optionsWidth={56}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneInput
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneInput`}
/>
<TysiaSelectOneArrow
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneArrow`}
 size="small"
 paddingLeft={0}
 paddingRight={0}
/>
<TysiaSelectOnePopover
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOnePopover`}
>
{childProps => (
<TysiaSelectOneOptions
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneOptions`}
/>
)}
</TysiaSelectOnePopover>
</React.Fragment>
)}
</TysiaSelectOneContent>
)}
</TysiaSelectOne>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="after"
/>
</div>
</div>
{children}
</React.Fragment>)
}